import React from 'react'
import {Alert} from "react-bootstrap";


export interface AlertItemProps {
    alertHeader: string,
    alertText: string,
    isVisible: boolean

    onClickClose()
}

export const AlertItem = ({onClickClose, isVisible, alertText, alertHeader}: AlertItemProps) =>
    <React.Fragment>
        {isVisible && <Alert style={{position:'absolute', top:'40px', width:'70%'}} variant="danger" onClose={onClickClose} dismissible>
            <Alert.Heading>{alertHeader}</Alert.Heading>
            <p>{alertText}</p>
        </Alert>}</React.Fragment>;
